module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [_c('md-whiteframe', {
    staticClass: "main-header",
    attrs: {
      "md-tag": "md-toolbar",
      "md-elevation": "1"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button nav-trigger",
    on: {
      "click": _vm.toggleSidenav
    }
  }, [_c('md-icon', [_vm._v("menu")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-title"
  }, [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), _c('md-button', {
    staticClass: "md-icon-button",
    attrs: {
      "rel": "noopener"
    },
    on: {
      "click": function($event) {
        _vm.signout()
      }
    }
  }, [_c('md-icon', [_vm._v("exit_to_app")])], 1)], 1), _vm._v(" "), _vm._t("default"), _vm._v(" "), (_vm.auth.isAdministrative) ? _c('md-bottom-bar', {
    attrs: {
      "md-shift": ""
    }
  }, [_c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "airport_shuttle"
    },
    nativeOn: {
      "click": function($event) {
        _vm.redirect('masters:color', 'blue')
      }
    }
  }, [_vm._v(" Entry ")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "notifications"
    },
    nativeOn: {
      "click": function($event) {
        _vm.redirect('masters:flow', 'teal')
      }
    }
  }, [_vm._v(" Request ")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "local_car_wash"
    },
    nativeOn: {
      "click": function($event) {
        _vm.redirect('masters:color', 'brown')
      }
    }
  }, [_vm._v(" Status ")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "history"
    },
    nativeOn: {
      "click": function($event) {
        _vm.redirect('masters:color', 'indigo')
      }
    }
  }, [_vm._v(" Histories ")]), _vm._v(" "), _c('md-bottom-bar-item', {
    attrs: {
      "md-icon": "place",
      "md-active": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.redirect('maps', 'blue-grey')
      }
    }
  }, [_vm._v(" Maps ")])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4823a9e2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageContent.vue
// module id = 557
// module chunks = 83